"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("@material-ui/icons");

var _FBUIConstants = require("../../../../utils/FBUIConstants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotificationIcon = function NotificationIcon(_ref) {
  var _Icons;

  var type = _ref.type,
      className = _ref.className;
  var Icons = (_Icons = {}, _defineProperty(_Icons, _FBUIConstants.NOTIFICATION_MESSAGE_TYPES.ERROR, /*#__PURE__*/_react.default.createElement(_icons.Error, {
    className: className
  })), _defineProperty(_Icons, _FBUIConstants.NOTIFICATION_MESSAGE_TYPES.INFO, /*#__PURE__*/_react.default.createElement(_icons.InfoOutlined, {
    className: className
  })), _defineProperty(_Icons, _FBUIConstants.NOTIFICATION_MESSAGE_TYPES.WARNING, /*#__PURE__*/_react.default.createElement(_icons.Warning, {
    className: className
  })), _defineProperty(_Icons, _FBUIConstants.NOTIFICATION_MESSAGE_TYPES.SUCCESS, /*#__PURE__*/_react.default.createElement(_icons.CheckCircle, {
    className: className
  })), _Icons);
  return Icons[type];
};

NotificationIcon.propTypes = {
  type: _propTypes.default.oneOf(Object.values(_FBUIConstants.NOTIFICATION_MESSAGE_TYPES)).isRequired,
  className: _propTypes.default.string
};
var _default = NotificationIcon;
exports.default = _default;

//# sourceMappingURL=NotificationIcon.js.map